import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import React, { useState } from "react";
import { AppBarButton, AppBarButtonProps } from "./AppBarButton";

const DEFAULT_CONFIRM_TEXT = "Continue";
const DEFAULT_CANCEL_TEXT = "Cancel";

export type AppBarConfirmButtonProps = AppBarButtonProps & {
  confirmLabel?: string;
  cancelLabel?: string;
  dataTest?: string;
  shouldNotClose?: boolean;
  onClose?: () => void;
};

export const AppBarConfirmButton: React.FC<AppBarConfirmButtonProps> = ({
  confirmLabel = DEFAULT_CONFIRM_TEXT,
  cancelLabel = DEFAULT_CANCEL_TEXT,
  dataTest,
  tooltip,
  children,
  onClick,
  shouldNotClose,
  onClose,
  ...props
}) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleConfirm: typeof onClick = (e) => {
    if (onClick) onClick(e);
    if (!shouldNotClose) setIsDialogOpen(false);
  };

  const handleClose = () => {
    onClose && onClose();
    setIsDialogOpen(false);
  };

  return (
    <React.Fragment>
      <AppBarButton
        data-test={dataTest}
        onClick={() => setIsDialogOpen(true)}
        tooltip={tooltip}
        {...props}
      />
      <Dialog maxWidth="md" fullWidth open={isDialogOpen} onClose={handleClose}>
        <DialogTitle>{tooltip}</DialogTitle>
        <DialogContent>{children}</DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
            color="primary"
            data-test={`${dataTest}-cancel`}
          >
            {cancelLabel}
          </Button>
          <Button
            onClick={handleConfirm}
            color="primary"
            data-test={`${dataTest}-confirm`}
          >
            {confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
